import axios from "axios"
import { API_URL, getHeader } from "../config"

export const getHighlight = async() => {
    const { data } = await axios.get(API_URL + `/api/highlight/TAFS`);
 
    return data;
} 
 
export const getNews = async() => { 
    const { data } = await axios.get(API_URL + `/api/news/TAFS`);
  
    return data;
} 
export const getNewsInner = async() => { 
    const { data } = await axios.get(API_URL + `/api/news/all/TAFS`);
   
    return data;
} 

export const getEvents = async() => {
    const { data } = await axios.get(API_URL + `/api/events/TAFS`);
    
    return data;
} 
export const getEventsinner = async ({page = 1, limit = 10, year = ""}) => {
     const url = `${API_URL}/api/events/all/limit/TAFS?page=${page}&limit=${limit}&year=${year}`;
     console.log('API URL:', url); // Debug log
     const { data } = await axios.get(url);
     console.log('Raw API Response:', data); // Debug log
     return data;
   };



export const getGallery = async() => {
    const { data } = await axios.get(API_URL + `/api/gallery/TAFS`);
  
    return data;
} 

export const getGalleryInner = async() => {
    const { data } = await axios.get(API_URL + `/api/gallery/All/TAFS`);
   
    return data;
} 

export const getSubGallery = async(id) => {
    console.log(id)
    const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
 
    return data;
} 

export const getNotification = async() => {
    const { data } = await axios.get(API_URL + `/api/notification/TAFS`,getHeader());
  
    return data;
} 

export const getTopper = async() => {
    const { data } = await axios.get(API_URL + `/api/topper/TAFS`,getHeader());
  
    return data;
} 

export const getOnlineRegistration = async() => {
    const { data } = await axios.get(API_URL + `/api/onlineRegistration/TAFS`,getHeader());
 
    return data;
} 


export const getPrincipalMessage = async() => {
    const { data } = await axios.get(API_URL + `/api/principalMessage/TAFS`, getHeader());
 
    return data;
} 
 
export const getVideo = async() => {
    const { data } = await axios.get(API_URL + `/api/video/All/TAFS`);
   
    return data;
} 
export const postTransferCertificate = async(name,admission) => {
    
    const { data } = await axios.post(API_URL + `/api/tc/TAFS`,{name,admission},getHeader());
    return data;
}
  
export const form1 = async (formData, header, type) => {
    try {
        const { data } = await axios.post(`${API_URL}/api/form/TAFS/${type}`, formData, header);
      
        return data;
    } catch (error) {
        console.error('Error in form submission:', error);
        if (error.response) {
            console.error('Error response data:', error.response.data); 
        }
        throw error;
    }
  };
  export const academicCalender = async() => {
    const { data } = await axios.get(API_URL + `/api/academicCalender/all/TAFS`, getHeader());
    
    return data;
}

export const getCircular = async() => {
    const { data } = await axios.get(API_URL + `/api/circular/all/TAFS`, getHeader());
   
    return data;
} 


export const getBirthdays = async() => {    
    const { data } = await axios.get(API_URL + `/api/birthdays/TAFS`);
 
     return data;
} 
export const getTestimonial = async() => {
    const { data } = await axios.get(API_URL + `/api/testimonials/TAFS`, getHeader());
    
    return data;
  } 